// extracted by css-extract-rspack-plugin
module.exports =  {"header":"e4835114f5","sliderNavigation":"ec4c0c6b1d","slider":"fa732d2ec9"};